module.exports = __webpack_public_path__ + "static/img/four.9f7d63c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/manyRecruitImg/four.png
// module id = 135k
// module chunks = 1